import moment from 'moment';

export const today = () => moment().format('YYYY-MM-DD');

export const isToday = (date: string) => date === today();

// YYYY-MM-DD strings compare correctly as text
export const isFutureDate = (date: string) => date > today();

export const formatDate = (value: string | null, format: string) =>
  value ? moment(value).format(format) : '';
